import axios from "axios";

const baseURL = process.env.VUE_APP_API_BASE_URL;
const service = axios.create({
  baseURL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

// 请求拦截器：添加token
service.interceptors.request.use(
  (config) => {
    let token = localStorage.getItem("token");
    const expire = localStorage.getItem("token_expire");
    if (token && expire && Date.now() > parseInt(expire, 10)) {
      localStorage.removeItem("token");
      localStorage.removeItem("token_expire");
      token = null;
    }

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 响应拦截器：统一处理错误
service.interceptors.response.use(
  (response) => {
    if (response.data && (response.data.code === 401 || response.data.status === 401)) {
      localStorage.removeItem("token");
      localStorage.removeItem("token_expire");
      if (window.location.pathname === '/' || window.location.pathname === '/pay-center') {
        window.location.reload();
      }
    }
    return response.data;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("token_expire");
      if (window.location.pathname === '/' || window.location.pathname === '/pay-center') {
        window.location.reload();
      }
    }
    const msg = error.response?.data?.message || "Request failed";
    return Promise.reject(new Error(msg));
  }
);

// 登录（根据用户ID）
export const loginUserId = (params) => service.post("/api/auth/loginUserId", params);

// 获取用户信息
export const getUserInfo = () => service.post("/api/user/info");

// 获取商品列表
export const getGoodsList = () => service.post("/api/goods/list");

// 获取支付方式列表
export const getPaymentMethods = () => service.post("/api/payment/methods");

// 获取优惠券
export const getCoupons = () => service.post("/api/user/coupons");

// 创建订单 (使用Deepgrow的API模式)
export const createOrder = (params) => service.post("/api/order/dg/create", params);

// 同步订单状态 (解除过期订单锁定的优惠券)
export const syncOrderStatus = () => service.post("/api/order/sync-status");

// 获取未完成订单
export const getUnfinishedOrder = (params) => service.post("/api/order/unfinished", params);

// 继续支付未完成订单
export const continuePayment = (orderId) =>
  service.post(`/api/order/continue/${orderId}`);

// 检查订单状态
export const checkOrderStatus = (orderId) =>
  service.post(`/api/order/check-status/${orderId}`);

// 获取当前国家信息
export const getCurrentCountry = () => {
  return service.post('/api/payment/country-info');
};

export default service;